import $ from 'jquery';
import {load} from '@shopify/theme-sections';
import Truncate from '../ui/truncate';
import '../sections/product';
import '../sections/product-gallery-slider';
import '../sections/product-grid-slider';
import '../../styles/templates/product.scss';
import '../app-extends/wishlist-plus/product-card';

load('*');

/**
 * Truncations
 */
$('.truncation').each((_, item) => {
  new Truncate(item, {
    length: 175,
  });
});
